import { Link, useNavigate } from "react-router-dom";
import { GLOBAL_IMAGES } from "../../assets/asset";

export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="w-full px-20 py-3 bg-transparent  fixed top-0 left-0 z-50">
      <div className="flex items-center gap-14">
        <Link to={"/"}>
          <img src={GLOBAL_IMAGES.dingo} className="h-20 w-auto" alt="logo" />
        </Link>
        <img
          src={GLOBAL_IMAGES.LoginBackButton}
          className="size-14 cursor-pointer"
          alt="back"
          onClick={() => navigate(-1)}
        />
      </div>
    </header>
  );
}
